module.exports = __webpack_public_path__ + "static/media/014ty@4x.74a87f3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/014ty@4x.png
// module id = 418
// module chunks = 0 1